import React, { useEffect } from 'react'
import { Card, Button, Dialog, Divider, TextField } from '@material-ui/core'
import ReactMarkdown from 'react-markdown'
export default function Keys({ api }) {
    const [keys, setKeys] = React.useState([])
    const [value, setValue] = React.useState('')
    const [showDialog, setShowDialog] = React.useState(false)
    const [selected, setSelected] = React.useState({})
    useEffect(() => {
        api.axios.get("configs")
            .then(d => {
                setKeys(d)
            })
    }, [])
    return (
        <div>
            <Dialog open={showDialog} fullScreen={true}>
                <div style={{ padding: 10 }}>
                    <h3>{selected.key}</h3>
                    <Divider />
                    <div style={{ maxHeight: 300, display: 'flex', justifyContent: 'center' }}>
                        <ReactMarkdown className="markdown" source={value} />
                    </div>
                    <Divider />
                    <br />
                    <TextField onChange={e => setValue(e.target.value)} fullWidth variant="outlined" multiline={true} rows={8} value={value} />
                    <br />
                    <br />

                    <div>
                        <Button onClick={e => setShowDialog(false)} color="secondary" variant="outlined">Cancel</Button>
                        &nbsp;&nbsp;
                        <Button onClick={e => {
                            api.axios.post("configs/edit/" + selected.key, {
                                value
                            })
                                .then(d => {
                                    setKeys(keys.map(s => {
                                        if (s.key === selected.key) {
                                            s.value = value;
                                        }
                                        return s;
                                    }))
                                    api.showSnack('Updated successfully', 'success')
                                    setShowDialog(false)
                                })
                                .catch(e => api.showSnack(e.error || 'Something went wrong.', 'error'))
                        }} color="primary" variant="outlined">Save</Button>
                    </div>
                </div>
            </Dialog>

            {keys.map(s => <Card key={s._id} style={{ padding: 14, margin: 5, display: 'flex' }}>
                <h3 style={{ flex: 1 }}>{s.key}</h3>
                <Button onClick={e => {
                    setSelected(s)
                    setValue(s.value)
                    setShowDialog(true)
                }} variant="outlined" color="primary">Edit</Button>
            </Card>)}
        </div>
    )
}
